<template>
  <div class="tax-card">
    <div class="tax-title">
      {{ result.templateName }}
    </div>
    <div class="tax-rate-box">
      <div class="tax-rate-left">
        <div class="tax-rate">消費税率</div>
        <div class="tax-rate-value">{{ result.taxRate }}%</div>
        <div class="tax-rate-method" v-show="result.decimalManageMethod == '01'">（切上）</div>
        <div class="tax-rate-method" v-show="result.decimalManageMethod == '02'">（切捨）</div>
        <div class="tax-rate-method" v-show="result.decimalManageMethod == '03'">（四捨五入）</div>
      </div>

      <div class="">
        <!--  照会バータン  -->
          <sp-smart-button v-auth="{ auth: '010221' }" @click="templateEdit()" class="edit-button with-100">{{$t('button.common.data.edit')}}</sp-smart-button>
      </div>
    </div>
  </div>
</template>

<script>

import SpSmartButton from "@/components/common/sp-smart-button"

export default {
  name: "saleTaxTemplateCard",
  components: {SpSmartButton},
  data() {
    return {

    };
  },
  props: {
    result:  {
      type: Object,
      default:()=>({})
    },
  },
  watch: {

  },
  mounted() {

  },
  methods: {
    templateEdit() {
      this.$emit("templateEdit", this.result.templateId);
    }
  },
};
</script>

<style scoped>
.tax-card {
  width: 516px;
  height: 156px;
  padding: 24px;
  border-radius: 8px;
  border: 1px solid #D4D4D4;
  background-color: #F7F7F2;
}
.tax-title {
  width: 468px;
  height: 48px;
  margin-bottom: 24px;
  font-family: Hiragino Kaku Gothic Pro;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: #525250;
  word-wrap: break-word;
}
.edit-button{
  width: 52px;
  height: 32px;
  padding: 5px 10px;
  border-radius: 8px;

}
.tax-rate-box {
  display: flex;
  justify-content: space-between;
}
.tax-rate-left {
  display: flex;
  align-items: baseline;
}
.tax-rate{
  font-family: Hiragino Kaku Gothic Pro;
  font-size: 16px;
  font-weight: 300;
  line-height: 24px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: #525250;
}
.tax-rate-value{
  font-family: Hiragino Kaku Gothic Pro;
  font-size: 24px;
  font-weight: 600;
  line-height: 36px;
  color: #329CA6;
  margin-left: 8px;
}
.tax-rate-method{
  font-family: Hiragino Kaku Gothic Pro;
  font-size: 16px;
  font-weight: 300;
  line-height: 24px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: #525250;
}
</style>
